import React, { useContext, useEffect, useState } from "react";
import { Navbar, Nav, Container, NavDropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faCheck,
    faUser, faUsers,
    faTools,
    faHomeAlt,
    faList,
    faSignOutAlt,
    faUserLock,
    faTruckMoving,
    faBuilding,
    faGlobeAmericas,
    faMapLocationDot,
    faCity,
    faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";
import * as Icon from 'react-bootstrap-icons';

const Menu: React.FC = () => {
    const authContext = useContext(AuthContext);

    const [expanded, setExpanded] = useState(false);
    const [theme, setTheme] = useState<"light" | "dark">("light");

    const handleSelect = () => {
        setExpanded(false);
    };

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") as "light" | "dark" | null;
        if (savedTheme) setTheme(savedTheme);
    }, []);

    useEffect(() => {
        document.documentElement.setAttribute("data-bs-theme", theme);
        document.body.setAttribute("data-bs-theme", theme);
        localStorage.setItem("theme", theme);
    }, [theme]);


    const toggleTheme = () => {
        setTheme((prev) => (prev === "light" ? "dark" : "light"));
         setExpanded(false);
    };

    return (<>
        <Navbar expand="lg" className=" border-bottom"
            expanded={expanded}
            onToggle={setExpanded}
            bg={theme}
            data-bs-theme={theme}>


            <Container fluid={true} >
                <Navbar.Brand as={Link} to={'/dashboard'}>
                    <div className='d-flex align-items-center'>
                        <FontAwesomeIcon icon={faHomeAlt} />

                    </div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto" onSelect={handleSelect}>
                        <NavDropdown title="Manifesto" id="basic-nav-dropdown" >
                            <NavDropdown.Item as={Link} to="/manifesto" onClick={handleSelect}>
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faTruckMoving} className="text-primary me-2 "
                                    />
                                    <span className="">MDF-es</span>
                                </div>
                            </NavDropdown.Item>

                            {authContext?.checkPermission('condutor_view') && (
                                <>
                                    <NavDropdown.Item as={Link} to="/condutor" onClick={handleSelect}>
                                        <div className="d-flex align-items-center">
                                            <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faUsers} className="text-warning me-2 "
                                            />
                                            <span className="">Condutores</span>
                                        </div>
                                    </NavDropdown.Item>

                                </>
                            )}
                            {authContext?.userLogado.is_superuser === 1 && (<>


                                <NavDropdown.Item as={Link} to="/empresa" onClick={handleSelect}>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faBuilding} className="text-success me-2 "
                                        />
                                        <span className="">Empresas</span>
                                    </div>
                                </NavDropdown.Item>

                                <NavDropdown.Item as={Link} to="/configs" onClick={handleSelect}>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faTools} className="text-primary me-2 "
                                        />
                                        <span className="">Configuração</span>
                                    </div>
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/assinatura" onClick={handleSelect}>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faMoneyBill} className="text-success me-2 "
                                        />
                                        <span className=""> Pagamentos</span>
                                    </div>
                                </NavDropdown.Item>

                            </>)}

                            <NavDropdown.Divider />

                            <NavDropdown.Item as={Link} to="/pais" onClick={handleSelect}>
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faGlobeAmericas} className="text-danger me-2 "
                                    />
                                    <span className="">Países</span>
                                </div>
                            </NavDropdown.Item>

                            <NavDropdown.Item as={Link} to="/estado" onClick={handleSelect}>
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faMapLocationDot} className="text-info me-2 "
                                    />
                                    <span className="">Estados</span>
                                </div>
                            </NavDropdown.Item>

                            <NavDropdown.Item as={Link} to="/municipio" onClick={handleSelect}>
                                <div className="d-flex align-items-center">
                                    <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faCity} className="text-success me-2 "
                                    />
                                    <span className="">Municipios</span>
                                </div>
                            </NavDropdown.Item>

                        </NavDropdown>
                        {authContext?.userLogado.is_superuser === 1 && (
                            <NavDropdown title="Segurança" id="basic-nav-dropdown" onSelect={handleSelect}>
                                <NavDropdown.Item as={Link} to="/profile">
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faUsers} className="text-primary me-2 "
                                        />
                                        <span className=""> Perfis de usuários</span>
                                    </div>
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/user" onClick={handleSelect}>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faUser} className="text-success me-2 "
                                        />
                                        <span className=""> Usuários</span>
                                    </div>
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/permission" onClick={handleSelect}>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faUserLock} className="text-danger me-2 "
                                        />
                                        <span className=""> Permissões</span>
                                    </div>
                                </NavDropdown.Item>


                            </NavDropdown>
                        )}
                        {authContext?.userLogado.is_staff === 1 && (<>

                            <NavDropdown title="Adminstrativo" id="basic-nav-dropdown" onSelect={handleSelect}>
                                <NavDropdown.Item as={Link} to="/devolucoes" onClick={handleSelect}>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faList} className="text-danger me-2 "
                                        />
                                        <span className="">Devoluções</span>
                                    </div>
                                </NavDropdown.Item>

                                <NavDropdown.Item as={Link} to="/cliente" onClick={handleSelect}>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faList} className="text-success me-2 "
                                        />
                                        <span className="">Clientes</span>
                                    </div>
                                </NavDropdown.Item>

                                <NavDropdown.Item as={Link} to="/rota" onClick={handleSelect}>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faList} className="text-primary me-2 "
                                        />
                                        <span className="">Rotas</span>
                                    </div>
                                </NavDropdown.Item>

                            </NavDropdown>

                        </>)
                        }

                    </Nav>

                    <Nav className="ms-auto" >
                        <NavDropdown title={<Icon.BuildingFillCheck className="" />}
                            id="basic-nav-dropdown" align="end" >

                            {authContext?.empresas?.filter(empresa => empresa.active === true)?.map((empresa: any) => (
                                <NavDropdown.Item

                                    className={empresa.id.toString() === authContext?.empresa?.toString() ? 'active2' : ''}
                                    key={empresa.id} onClick={() => authContext.changeEmpresa(empresa.id)}  > {
                                        empresa.id.toString() === authContext?.empresa?.toString() ?
                                            <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faCheck} /> : ''
                                    } {empresa.xfant}</NavDropdown.Item>
                            ))}

                        </NavDropdown>
                    </Nav>


                    {/* <Button
                        title="Trocar tema"
                        className="rounded-circle"
                        variant={theme === "light" ? "secondary" : "light"}
                        onClick={toggleTheme}
                        size="sm"

                    >
                        {theme === "light" ? "🌙" : "☀️"}
                    </Button> */}
                    <div className=" p-2">
                        <div style={{ cursor: 'pointer' }}
                            title="Trocar tema"
                            className="rounded-circle "
                            onClick={toggleTheme}
                        >
                            {theme === "light" ? "🌙" : "☀️"}
                        </div>
                    </div>

                    <Nav className="" >
                        <NavDropdown title={authContext?.user} id="basic-nav-dropdown" align="end">

                            {authContext?.isAuthenticated && <NavDropdown.Item onClick={authContext.logout}>
                                <FontAwesomeIcon style={{ minWidth: '1.25rem' }} className="text-danger" icon={faSignOutAlt} />  Sair</NavDropdown.Item>}
                        </NavDropdown>
                    </Nav>

                </Navbar.Collapse>
            </Container>
        </Navbar >


    </>);
}

export default Menu;